import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LineDetail, AssetDetailsResponse } from '@models/asset-details.model';
import { StoreEndpointsConstant } from '@shared/constants/store-endpoints.constant';
import { UrlUtils } from '@shared/utils/url.utils';
import { Observable } from 'rxjs';
import { dataLoaderContext } from 'tangoe-design-system';

@Injectable({
  providedIn: 'root'
})
export class AssetDetailsService {
  constructor(
    private http: HttpClient,
    private url_utl: UrlUtils
  ) {}

  index(line_id: string | number, key?: string): Observable<AssetDetailsResponse> {
    return this.http.get<AssetDetailsResponse>(
      this.url_utl.parseURL(StoreEndpointsConstant.LINE_DETAILS, { id: line_id }),
      {
        context: dataLoaderContext(key ?? 'asset-details')
      }
    );
  }

  deviceDetails(device_id: number, key?: string): Observable<AssetDetailsResponse> {
    return this.http.get<AssetDetailsResponse>(
      this.url_utl.parseURL(StoreEndpointsConstant.DEVICE_DETAILS, { id: device_id }),
      {
        context: dataLoaderContext(key ?? 'asset-details')
      }
    );
  }
}
